import { useState, useContext, useRef, useEffect } from 'react'
import { SceneContext }     from './SceneContext'
import Button               from '@material-ui/core/Button'
import Checkbox             from '@material-ui/core/Checkbox'
import CloudUploadIcon      from '@material-ui/icons/CloudUpload'
import FormControlLabel     from '@material-ui/core/FormControlLabel'
import LockTwoToneIcon      from '@material-ui/icons/LockTwoTone'
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined'
import deepOrange           from '@material-ui/core/colors/deepOrange'

import { JSONEditor } from 'svelte-jsoneditor/dist/jsoneditor.mjs'
import './css/SceneMenu.css'

let json_editor = {}

export default function SceneMenu() {
    
    const [lock, setLock]               = useState(false)
    const [msg, setMsg]                 = useState('')
    const context                       = useContext(SceneContext)

    useEffect(()=> {
        json_editor = new JSONEditor({
            target: document.getElementById('jsoneditor'),
            props: {
                mode: 'code',
                mainMenuBar: false,
                json: {},
                onChange: (content) => {
                    console.log('onChange', content)
                }
            }
        })
    }, [])

    useEffect(()=>{
        updateEditor()
    }, [context.selected_scene_data, context.display_map, context.map_data, context.selected_scene_data?.AudioBoxes, context.selected_scene_data?.NavButtons])

    const updateEditor = () => {
        json_editor.update(context.display_map ? JSON.parse(JSON.stringify(context.map_data)) : JSON.parse(JSON.stringify(context.selected_scene_data)))
    }

    const updateSceneClick = async () => {
        setMsg('⌛ Uploading data...')
    
        let edited_data
        try {
            edited_data = json_editor.get()
            console.log(edited_data)
            context.updateSceneData(edited_data)
    
            let full_scene_data = {
                [context.selected_scene]: edited_data
            }
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(full_scene_data)
            }
            
            let response = await fetch(context.URL.base + context.URL.update_scene, requestOptions)
            response = await response.json()
            console.log(response)
            context.updateScenesList(response)
            console.log('Scene updated')
            setMsg('🥰 Scene updated!')
            
        } catch (e) {
            setMsg('ERROR. Bad JSON format or connection error')
        }
    }

    const saveMapClick = async () => {
        setMsg('⌛ Uploading map data...')
            
        let edited_data
        try {
            edited_data = json_editor.get()
            console.log(edited_data)
            
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(edited_data)
            }
            
            let response = await fetch(context.URL.base + context.URL.update_map, requestOptions)
            response = await response.json()
            console.log(response)
            context.updateMapData(response)
            setMsg('🥰 Map updated!')
            
        } catch (e) {
            setMsg('ERROR. Bad JSON format or connection error')
        }
    }

    const updateMapClick = () => {
        let edited_data
        try {
            edited_data = json_editor.get()
            console.log(edited_data)
            context.updateMapData(edited_data)
        } catch (e) {
            setMsg('ERROR. Bad JSON format or connection error')
        }
    }

    const copyToClipboard = () => {
        let edited_data
        try {
            edited_data = json_editor.get()
            edited_data = JSON.stringify(edited_data, null, 4)
            navigator.clipboard.writeText(edited_data)
            setMsg('📋 Data in clipboard!')
        } catch(e) {
            setMsg('ERROR. Bad JSON format.')
        }
    }
    
    const checkbox = () => {
        return (
            <FormControlLabel
                style={{ float:'right', marginTop:'8px', fontSize:'10px' }}
                classes={{ label: 'lock-label' }}
                label="Lock menu"
                control={   <Checkbox 
                                name="checkedH"
                                size="small"
                                onClick = { () => setLock(e=>!e) }
                                icon = { <LockOpenOutlinedIcon style={{ color: deepOrange[50] }} />}
                                checkedIcon={ <LockTwoToneIcon style={{ color: deepOrange[500] }} />} 
                            /> } 
            />
        )
    }
    
    const buttons = () => {

        if(!context.display_map) {
            return (
                <div>
                    <Button variant="contained" 
                            size="small"
                            color="primary"
                            style={{marginRight: "20px"}}
                            startIcon={ <CloudUploadIcon /> }
                            onClick={() => updateSceneClick()}>
                        Save scene
                    </Button>
                    
                    <Button variant="contained" 
                            size="small"
                            color="primary"
                            style={{marginRight: "20px"}}
                            onClick={() => copyToClipboard()}>
                        Copy JSON
                    </Button>
    
                    <Button variant="contained" 
                            size="small"
                            color="primary"
                            style={{marginRight: "20px"}}
                            onClick={() => {context.addButtonsVereda(); updateEditor()}}>
                        (+) nav vereda
                    </Button>
    
                    <Button variant="contained" 
                            size="small"
                            color="primary"
                            style={{marginRight: "20px"}}
                            onClick={() => {context.addButtonsEsquina(); updateEditor()}}>
                        (+) nav esquina
                    </Button>
    
                    <Button variant="contained" 
                            size="small"
                            color="primary"
                            style={{marginRight: "20px"}}
                            onClick={() => {context.addAudioBox(); updateEditor()}}>
                        (+) AudioBox
                    </Button>
    
                    <Button variant="contained" 
                            size="small"
                            color="primary"
                            style={{marginRight: "20px"}}
                            onClick={() => {context.addNavButton(); updateEditor()}}>
                        (+) nav
                    </Button>
                    
                </div>
            )
        } else {
            return (
                <div>
                    <Button variant="contained" 
                            size="small"
                            color="primary"
                            style={{marginRight: "20px"}}
                            onClick={updateMapClick}>
                        Display changes
                    </Button>

                    <Button variant="contained" 
                            size="small"
                            color="primary"
                            style={{marginRight: "20px"}}
                            startIcon={ <CloudUploadIcon /> }
                            onClick={saveMapClick}>
                        Save map
                    </Button>
                    
                    <Button variant="contained" 
                            size="small"
                            color="primary"
                            style={{marginRight: "20px"}}
                            onClick={() => copyToClipboard()}>
                        Copy JSON
                    </Button>
                    
                </div>
            )
        }
        
    }
    
    const compute_style = () =>{
        let style = {}
    
        if(lock) {
            style.opacity = '1'
            style.width = '700px'
        }
    
        if(context.dev_mode)
            style.display = "block"
        else
            style.display = "none"
    
        return style
    }

    const title = () => {
        if(!context.display_map) 
            return <h1 style={{ float:'left' }}>{ context.selected_scene } scene editor</h1>
        else
        return <h1 style={{ float:'left' }}>Map editor</h1>
    }

    return (
        <div id="scene-menu" style={ compute_style() }>
            <div style={{margin:'10px 20px'}}>
                <div style={{ height:'50px' }}>
                    { title() }
                    { checkbox() }
                </div>

                <div id="jsoneditor"></div>
                <div style={{ height:'10px' }}></div>
                { buttons() }
                
                <div style={{color:'white', fontSize: '14px', marginTop: '10px'}}>
                    { msg }
                </div>
                
            </div>
        </div>
    )
}




